import { render } from "./AddHistoriquePage.vue?vue&type=template&id=6ee0af7d&ts=true"
import script from "./AddHistoriquePage.vue?vue&type=script&lang=ts"
export * from "./AddHistoriquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__